import { useRef, useState } from "react";
import { useStaffNames } from "@/hooks/useStaffNames";

// Textarea with an @-mention picker for staff names
export function MentionTextarea({ value, onChange, className = "", ...rest }) {
  const names = useStaffNames();
  const ref = useRef(null);
  const [query, setQuery] = useState(null);
  const matches = query === null ? [] : Object.values(names).filter((n) => n.toLowerCase().startsWith(query.toLowerCase())).slice(0, 6);

  const handle = (e) => {
    onChange(e.target.value);
    const before = e.target.value.slice(0, e.target.selectionStart);
    const m = before.match(/(^|\s)@([^@\n]{0,30})$/);
    setQuery(m ? m[2] : null);
  };
  const pick = (name) => {
    const el = ref.current; const caret = el.selectionStart;
    const before = value.slice(0, caret).replace(/@([^@\n]{0,30})$/, `@${name} `);
    onChange(before + value.slice(caret)); setQuery(null);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(before.length, before.length); });
  };

  return (
    <div className="relative">
      <textarea ref={ref} value={value} onChange={handle} onBlur={() => setTimeout(() => setQuery(null), 150)} className={className} {...rest} />
      {matches.length > 0 && (
        <div data-testid="mention-picker" className="absolute z-20 left-2 top-full -mt-1 w-56 rounded-lg border border-slate-200 bg-white shadow-lg py-1">
          {matches.map((n) => (
            <button key={n} type="button" data-testid={`mention-option-${n.replace(/\s+/g, "-").toLowerCase()}`} onMouseDown={(e) => { e.preventDefault(); pick(n); }}
              className="w-full text-left px-3 py-1.5 text-sm text-slate-700 hover:bg-primary/5">@{n}</button>
          ))}
        </div>
      )}
    </div>
  );
}

// Render note text with @mentions highlighted
export function MentionText({ text }) {
  const names = Object.values(useStaffNames()).sort((a, b) => b.length - a.length);
  if (!names.length || !text.includes("@")) return text;
  const rx = new RegExp(`(@(?:${names.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")}))(?![\\w])`, "gi");
  return text.split(rx).map((part, i) => (i % 2 ? <span key={i} className="font-semibold text-primary">{part}</span> : part));
}
